/*
 * Copyright (c) 2022. American Express Company
 */

import React from 'react';

import styles from './divider.module.scss';
import { DividerViewModel } from 'src/types/view-models/atoms/divider.view.model';

/**
 * Good example of when not to use declarative classes
 * This element will already need 1 local class,
 *      so why not include the background color with it instead of assigning 2 classes
 * Declarative classes are best for things that vary,
 *      if we make this component change color then declarative classes from globalStyles would appropriate
 */

export default function Divider({ color, className, orientation = 'horizontal' }: DividerViewModel): JSX.Element {
    const classes = orientation === 'horizontal' ? [styles.dividerHorizontal] : [styles.dividerVertical];
    if (color === 'weak') {
        classes.push(styles.borderWeak);
    } else if (color === 'strong') {
        classes.push(styles.borderStrong);
    } else {
        classes.push(styles.borderDefault);
    }

    return <div className={`${classes.join(' ')} ${className}`} />;
}
